// GUI pin component
AFRAME.registerComponent("spot", {
    init: function () {
        var el = this.el;

        var spot = document.createElement("a-entity");
        spot.setAttribute('geometry', 'primitive: ring; radiusInner: 0.025; radiusOuter: 0.03;');
        spot.setAttribute('material', 'shader: flat; opacity: 0.75; color: white');
        spot.setAttribute('rotation', '-90 0 0');
        spot.setAttribute('position', '0 0.01 0');

        spot.setAttribute('animation__size', {
            property: 'geometry.radiusOuter',
            dir: 'alternate',
            dur: '750',
            loop: 'true',
            from: '0.03',
            to: '0.04'
        });
        spot.setAttribute('animation__opacity', {
            property: 'material.opacity',
            dir: 'alternate',
            dur: '750',
            loop: 'true',
            from: '0.75',
            to: '0.25'
        });


        el.appendChild(spot);

    }    
});

// GUI pin component
AFRAME.registerComponent("pin", {
    multiple: true,
    schema: {
        on: {default: 'click'},
        xpos: {
            type: 'number',
            default: 0
        },
        zpos: {
            type: 'number',
            default: 0
        },
        url: {
            type: 'string',
            default: ''
        },
        clickAction: {type: 'string'}
    },
    init: function () {
        var data = this.data;
        var el = this.el;

        var pinBase = document.createElement("a-entity");
        pinBase.setAttribute('geometry', 'primitive: cone; radiusBottom: 0.00001; radiusTop: 0.05; height: 0.18;');
        pinBase.setAttribute('material', 'shader: flat; opacity: 0.75; color: #000; side:back');
        pinBase.setAttribute('position', `${data.xpos} 0.1 ${data.zpos}`);
        pinBase.className = 'clk';
        el.appendChild(pinBase);

        var pinTop = document.createElement("a-entity");
        pinTop.setAttribute('geometry', 'primitive: sphere; radius: 0.05; phiLength:360;');
        pinTop.setAttribute('material', 'shader: flat; opacity: 0.75; color: #333; side:back');
        pinTop.setAttribute('position', '0 0.1 0');
        pinTop.setAttribute('rotation', '-90 0 0');
        pinBase.appendChild(pinTop);

        var pinTopInner = document.createElement("a-entity");
        pinTopInner.setAttribute('geometry', 'primitive: sphere; radius: 0.035;');
        pinTopInner.setAttribute('material', 'opacity: 1; color: #999');

        pinTop.appendChild(pinTopInner);

        pinBase.addEventListener("mouseenter", function () {
            this.setAttribute("scale", "1.25 1.25 1.25");
            pinTopInner.setAttribute("material", "color:#fff;");
        });

        pinBase.addEventListener("mouseleave", function () {
            this.setAttribute("scale", " 1 1 1");
            pinTopInner.setAttribute("material", "color:#999;");
        });

        pinBase.addEventListener(data.on, function () {
            this.setAttribute("scale", "1.25 1.25 1.25");
            pinTopInner.setAttribute("material", "color:#91A076;");
            var clickActionFunctionName = data.clickAction;
            console.log("BTN in button, clickActionFunctionName: "+clickActionFunctionName);
            var clickActionFunction = window[clickActionFunctionName];
            if (typeof clickActionFunction === "function") clickActionFunction();

        });

    }
});


//////////////////
// WEBPACK FOOTER
// ./src/pin.js
// module id = 11
// module chunks = 0